<template>
  <div class="anonymous-chat-window-wrap">
    <!-- {{activeAnonymousUser}} -->
    <div class="chat-head pa-3" v-if="activeAnonymousUser">
      <v-row no-gutters>
        <v-col cols="4">
          <div class="left-side">
            <div class="icon">
              <v-avatar size="50" class="profile-avatar">
                <img :src="getImgUrl('anonymous-user')" alt="user-image">
              </v-avatar>
            </div>
            <div class="user-title" v-if="activeAnonymousUser.anonymous_name">
              {{activeAnonymousUser.anonymous_name}}
            </div>
          </div>
        </v-col>
        <v-col cols="8">
          <v-row no-gutters>
            <v-col class="mx-2">
              <v-select
                v-model="empStatus"
                :items="actions"
                label="Resolution status"
                outlined
                hide-details
                class=""
                dense
                type="select"
                item-value="status"
                :disabled="activeAnonymousUser.status && activeAnonymousUser.status !== 'Na' ? false : true"
              >
                <template v-slot:item="{item}">
                  <v-list class="pa-0">
                    <v-list-item class="pa-0" :disabled="item.disabled">
                      <v-list-item-avatar>
                        <v-icon>{{item.icon}}</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        {{item.text}}
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </template>
              </v-select>
            </v-col>
              <v-col class="mx-2">
                <v-combobox
                  v-model="activeAnonymousUser.assignedTo_name"
                  :items="assignedToList"
                  label="Assigned to"
                  @change="updateAssignedTo(activeAnonymousUser.assignedTo_name, 'assign')"
                  outlined
                  class=""
                  hide-details
                  dense
                >
                  <template v-slot:prepend-item>
                    <v-list v-if="activeAnonymousUser.assignedTo">
                      <v-list-item @click="updateAssignedTo( 'remove', 'assign')">
                        Remove assignee
                      </v-list-item>
                    </v-list>
                  </template>
                  <template v-slot:item="{item}">
                    <div>
                      {{item.text}}
                    </div>
                  </template>
                </v-combobox>
              </v-col>
            <v-col>
              <v-btn
                slot="activator"
                color="primary"
                outlined
                @click.stop="requestIdentity(activeAnonymousUser)"
              >
                <v-icon small class="mr-2">lar la-id-card</v-icon>
                Request Identity
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <v-col v-if="!activeAnonymousUser.conversation_list.length === 0" style="align-self: center;
    position: relative;
    padding: 0;">
      <div class="no-sort-data text-center" style="    position: absolute;
    z-index: 11;
    top: 38vh;
    left: 35%;">
        No anonymous message.
      </div>
    </v-col>
    <div v-if="activeAnonymousUser" class="chat-body" style="">
      <div class="chat-content scroller">
        <!-- eslint-disable -->
        <div  v-if="activeAnonymousUser.conversation_list.length > 0"
          v-for="(c, ci) in chatTranscript" :key="ci"
          :class="c.createdBy_name === null ? 'chat' : 'chat-reverse'"
        >
          <div class="chat-avatar" v-if="c.createdBy_name === null">
            <v-avatar
              size="35"
              :class="{'black': c.createdBy_name === null}"
            >
              <span v-if="c.createdBy_name === null"
                class="white--text"
                title="Anonymous"
              >
                A
              </span>
            </v-avatar>
          </div>
          <div class="chat-message">
            <p class="msg"
              :style="{
                'float': c.createdBy_name !== null ? 'right' : '',
              }"
            >
              <span v-if="c.conversation_message" v-html="c.conversation_message"></span><br>
              <span style="float:right">{{dayjs(c.createdAt).format('DD MMM YYYY')}} {{dayjs(c.createdAt).format('hh:mm')}}</span>
            </p>
          </div>
          <div class="chat-avatar-wrap" v-if="c.createdBy_name">
            <div class="chat-avatar">
              <v-avatar size="35" class="primary">
                <span
                  class="white--text"
                  :title="c.createdBy_name"
                >
                  {{getAvatar(c.createdBy_name)}}
                </span>
              </v-avatar>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="activeAnonymousUser" class="chat-footer">
      <div class="chat-attagement">
        <!-- <v-icon>far fa-smile</v-icon> -->
      </div>
      <div class="input-area">
        <v-textarea
          solo
          name="chatWindow"
          class="chat-message"
          label="Solo textarea"
          auto-grow
          placeholder="Type your message...."
          ref="chatMessage"
          :rows="1"
          hide-details
          v-model="chatTranscript.message"
        ></v-textarea>
      </div>
      <v-btn color="primary" class="mr-2" @click="sendMessage(chatTranscript.message)">
        <v-icon>fas fa-paper-plane</v-icon>
        <span>&nbsp;&nbsp;</span>
        <span>Send</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

// import AnonymousChat from '../../elements/AnonymousChat';

export default {
  name: 'AnonymousChatWindow',

  components: {
  },

  data () {
    return {
      assignedToList: [],
      activeAnonymousUser: null,
      actions: [
        {
          text: 'Schedule meeting',
          icon: 'lar la-calendar-alt',
          status: 'scheduled',
          dialog: 'OneOnOne',
          disabled: true,
          action: this.openDialog,
          permission: ['schedule_invite']
        }, {
          text: 'Work In Progress',
          icon: 'las la-tasks',
          status: 'inProgress',
          disabled: false,
          dialog: 'inProgress',
          action: this.updateStatus,
          permission: ['change_status']
        }, {
          text: 'Resolved',
          icon: 'las la-check',
          status: 'resolved',
          disabled: false,
          dialog: 'resolved',
          action: this.updateStatus,
          permission: ['change_status']
        }
      ],
      chatTranscript: [],
      adminUsersList: [],
      // empAsssignedTo: { text: 'Sameer .', id: '59c7a940-e54c-4b9f-9a6d-ef74937eb3cb' },
      empAsssignedTo: null,
      empStatus: null
    };
  },

  created () {
    this.getAssignedTo();
  },

  computed: {
    ...mapState({
      user: state => state.user,
      users: state => state.companyUsersList,
      adminUsers (state) {
        const adminUsers = state.companyAdminsList;
        return adminUsers;
      }
    })
  },

  watch: {
    activeAnonymousUser: {
      deep: true,
      immediate: true,
      handler () {
        if (this.activeAnonymousUser && this.activeAnonymousUser.assignedTo) {
          this.$lodash.each(this.assignedToList, (val) => {
            if (val.id === this.activeAnonymousUser.assignedTo) {
              this.empAsssignedTo = val.text;
            }
          });
        } else {
          this.empAsssignedTo = null;
        }
        if (this.activeAnonymousUser && this.activeAnonymousUser.status) {
          this.empStatus = this.activeAnonymousUser.status;
        }
      }
    },
    empStatus: {
      deep: true,
      // immediate: true,
      handler () {
        if (this.empStatus && this.activeAnonymousUser.status !== this.empStatus) {
          if (this.empStatus === 'inProgress') {
            this.updateResolutionStatus('inProgress', ['change_status']);
          }
          if (this.empStatus === 'resolved') {
            this.updateResolutionStatus('resolved', ['change_status']);
          }
        }
      }
    }
  },

  methods: {
    sendMessage (message) {
      const response = {
        type: 'text',
        createdBy_name: this.user.display_name,
        conversation_message: message
      };
      this.addResponse(message);
      this.chatTranscript.message = '';
      this.chatTranscript.push(response);
      this.scrollToBottom();
    },
    addResponse (msg) {
      const responseData = {
        anonymousMessage: this.activeAnonymousUser.id,
        company: this.user.company,
        createdBy: this.user.email,
        conversation_message: msg
      };
      axios.post(`${process.env.VUE_APP_BASE_API_URL}anonymous_bot/message/conversation/add`, responseData).then((resp) => {
        if (resp && resp.data) {
          //
        } else {
          // Show error on the user's end
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to send message, Please try again later!'
          });
        }
      });
    },
    getAssignedTo () {
      const tempList = [];
      axios.get(`${process.env.VUE_APP_API_URL}users/admins`).then((response) => {
        if (response && response.data.data && response.data.data.length > 0) {
          this.$lodash.each(response.data.data, (val) => {
            const t = {};
            t.text = val.display_name;
            t.id = val.user_id;
            tempList.push(t);
          });
        } else {
          const noData = {};
          noData.title = 'No data available';
          noData.id = null;
          tempList.push(noData);
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to get details, Please try again later!'
          });
        }
      });
      this.assignedToList = []; // for reset the existing data
      this.assignedToList = tempList;
    },
    getImgUrl (pet) {
      const images = require.context('@/assets/', false, /\.png$/);
      return images(`./${pet}.png`);
    },
    getAdditionalDetails (user) {
      axios.get(`${process.env.VUE_APP_BASE_API_URL}anonymous_bot/message/details/${user.id}`, {
        params: {
          fields: 'message,status,createdAt,anonymous_name,assignedTo,assignedTo_email,assignedTo_name,company,conversation_list'
        }
      }).then((response) => {
        if (response && response.data) {
          this.activeAnonymousUser = response.data;
          this.loadChat();
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to get details, Please try again later!'
          });
        }
      });
    },
    loadChat () {
      this.$lodash.each(this.activeAnonymousUser.message.reverse(), (m) => {
        this.activeAnonymousUser.conversation_list.push({
          conversation_message: m.text,
          createdBy_name: null
        });
      });
      this.chatTranscript = this.activeAnonymousUser.conversation_list.reverse();
    },
    checkPermission (permission) {
      let flag = false;
      this.$lodash.each(this.user.permissions, (perm) => {
        this.$lodash.each(permission, (v) => {
          if (v === perm) {
            flag = true;
          }
        });
      });
      return flag;
    },
    requestIdentity (m) {
      axios.post(`${process.env.VUE_APP_BASE_API_URL}anonymous_bot/ir/request`, {
        anonymous_message_id: m.id
      }).then((response) => {
        if (response && response.data) {
          this.$store.dispatch('updateSnackbar', {
            color: 'success',
            show: true,
            text: 'Identity request sent successfully!'
          });
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to perform action, Please try again later!'
          });
        }
      });
    },
    getAvatar (n) {
      const name = n.split(' ');
      const avt = `${name[0].charAt(0)}${name[1] ? name[1].charAt(0) : ''}`;
      return avt.toUpperCase();
    },
    updateResolutionStatus (value, permission) {
      // for update resolution status
      if (this.checkPermission(permission)) {
        this.updateStatus(value, 'status');
      } else {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Unable to update status, You don\'t have permission!'
        });
      }
    },
    updateAssignedTo (val, val1) {
      this.updateStatus(val, val1);
    },
    updateStatus (val, type) {
      const queryParams = {};
      if (type === 'assign') {
        if (val === 'remove') {
          queryParams.assignedTo_id = null;
        } else {
          queryParams.assignedTo_id = val.id;
        }
      }
      if (type === 'status') {
        queryParams.status = val;
      }
      axios.patch(`${process.env.VUE_APP_BASE_API_URL}anonymous_bot/message/update/${this.activeAnonymousUser.id}`, {
        ...queryParams
      }).then((response) => {
        if (response && response.data) {
          this.$store.dispatch('updateSnackbar', {
            color: 'success',
            show: true,
            text: 'Message details updated!'
          });
          this.getAdditionalDetails(this.activeAnonymousUser);
          this.$emit('updateUserList');
        } else {
          this.config.loading = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to update message details, Please try again later!'
          });
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to update message details, Please try again later!'
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.anonymous-chat-window-wrap {
  display: grid;
  grid-template-rows: auto 1fr auto;
  max-height: calc(100vh - 180px);
  .chat-head {
    // background-color: var(--primary-dark);
    // background-color: var(--bg);
    // background-color: #a798ff;
    // background-color: #cec7fb;
    background-color: #ffffff;
    // background-color: var(--bg);
    // display: flex;
    // justify-content: space-between;
    border-radius: 0px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .left-side {
      display: flex;
      .user-title {
        font-size: 16px;
        font-weight: 500;
        padding: 10px;
        padding-bottom: 0;
      }
      .icon {
        img {
          // border: 2px solid #898989;
        }
      }
    }
    .right-side {
      // display: flex;
      font-size: 16px;
    }
  }
  .chat-body {
    background-color: #e6e6e67d;
    padding: 0;
  }
  .chat-content {
    position: relative;
    padding: 1.4rem;
    overflow-y: auto;
    overflow-x: hidden;
    // background-color: var(--bg);
    // background-color: #cec7fb;
    // background-image: url('/img/background.jpg');
    background-image: url('../../../assets/img-bg-3.png');
    background-repeat: repeat;
    height: calc(100vh - 300px);
    padding: 16px;
    .chat {
      display: grid;
      // grid-template-columns: max-content auto;
      grid-template-columns: max-content minmax(auto, 70%);
      grid-gap: 10px;
      align-items: unset;
      .msg {
        // width: 50%;
        max-width: 67%;
        background-color: var(--bg);
        color: var(--color-text);
        display: table;
        min-height: 40px;
        margin-bottom: 20px;
        background: white;
        min-width: 50px;
        padding: 10px;
        margin-left: 2px;
        border-radius: 5px;
        position: relative;
        -webkit-box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.07);
        box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.07);
      }
      .msg::after {
        bottom: 100%;
        left: 7%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        transform: rotate(-90deg);
        position: absolute;
        pointer-events: none;
        border-bottom-color: #ffffff;
        border-width: 10px;
        margin-left: -7px;
        border-bottom-color: #ffffff;
        left: -10px;
        top: 10px;
      }
    }
    .chat-reverse {
      display: grid;
      grid-template-columns: auto max-content;
      // grid-template-columns: minmax(auto, 50%) max-content;
      grid-gap: 10px;
      align-items: unset;
      .msg {
        display: table;
        min-height: 40px;
        margin-bottom: 20px;
        background: white;
        min-width: 50px;
        padding: 10px;
        border-radius: 5px;
        -webkit-box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.07);
        box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.07);
        // width: 50%;
        max-width: 50%;
        position: relative;
        margin-right: 2px;
        // right: 8%;
        background-color: var(--primary-dark);
        color: var(--bg);
      }
      .msg::after {
        bottom: 100%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        transform: rotate(90deg);
        position: absolute;
        pointer-events: none;
        border-bottom-color:var(--primary-dark);
        border-width: 10px;
        border-bottom-color:var(--primary-dark);
            margin-right: -2px;
        right: -15px;
        top: 10px;
      }
    }
  }
  .chat-footer {
    // background-color: #cec7fb;
    // background-color: #d8d4ff;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    // background-color: var(--bg);
    display: grid;
    grid-template-columns: max-content 1fr max-content;
    align-items: end;
    padding: 0.4rem 0;
    place-items: center;
    .chat-attagement {
      padding: 1rem;
    }
    .input-area {
      overflow-y: auto;
      margin-right: 16px;
      width: 100%;
      .chat-message {
        max-height: 100px;
      }
    }
  }
}
</style>
<style lang="scss">
  .chat-footer {
    .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
      box-shadow: none !important;
      border: 1px solid rgba(0, 0, 0, 0.1);
    }
  }
</style>
